import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ControlOutlinedSvg from "@ant-design/icons-svg/es/asn/ControlOutlined";
import AntdIcon from "../components/AntdIcon";
var ControlOutlined = function ControlOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ControlOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ControlOutlined.displayName = 'ControlOutlined';
}
export default /*#__PURE__*/React.forwardRef(ControlOutlined);